import o from"styled-components";import{theme as i}from"../../../../../theme.js";const r=o.div`
  max-height: 500px;
  position: relative;
  background-color: ${i.colors.gray[50]};
  border-radius: ${i.spacing}px;
  > img {
    width: 100%;
    max-height: 444px;
    object-fit: contain;
    border-radius: ${i.radius}px;
  }
  > button {
    position: absolute;
    top: 16px;
    right: 16px;
    background-color: ${i.colors.gray[100]};
    z-index: 2;
  }
  .more {
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 24px;
    font-weight: 700;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    color: ${i.colors.shades[0]};
    top: 0;
    left: 0;
    border-radius: ${i.radius}px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`,t=o.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  padding: 0 ${i.spacing*4}px;
  height: fit-content;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.md}) {
    padding: ${i.spacing*4}px;
  }
`,e=o.div`
  display: flex;
  align-items: center;
  padding: 0 ${i.spacing*6}px;
  height: 56px;
  border-radius: 0 0 6px 6px;
  background-color: ${i.colors.gray[100]};
`;export{t as ListContainer,r as PictureContainer,e as SettingsContainer};
